import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  ProcedureAttivita,
  IsError,
  IProcedureAttivita_SequenzaModel,
  IProceduraAttivita_RenderViewModel,
} from '../../models/-index';

@Injectable()
export class ProcedureAttivitaService extends CrudGenericsService<ProcedureAttivita, number> {
  private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ProcedureAttivita`);
    this.base = `${env.apiUrl}/api/ProcedureAttivita/`;
  }

  public GetForChecklist_ByProcedura(id: number): Observable<ProcedureAttivita[]> {
    const url = this.base + 'GetForChecklist_ByProcedura?id=' + id;
    return this.http.get<ProcedureAttivita[]>(`${url}`);
  }
  AddTo_Checklist(item: ProcedureAttivita): Observable<ProcedureAttivita> {
    const url = this.base + 'AddTo_Checklist';
    return this.http.post<ProcedureAttivita>(`${url}`, item);
  }
  RemoveFrom_Checklist(id: number): Observable<IsError> {
    const url = this.base + 'RemoveFrom_Checklist?id=' + id;
    return this.http.delete<IsError>(`${url}`);
  }
  UpdateFrom_Checklist(item: ProcedureAttivita) {
    const url = this.base + 'UpdateFrom_Checklist';
    return this.http.post(`${url}`, item);
  }
  UpdateSequenza_Checklist(model: IProcedureAttivita_SequenzaModel[]) {
    const url = this.base + 'UpdateSequenza_Checklist';
    return this.http.post(`${url}`, model);
  }
  // get readoly model
  public GetForChecklistReadonly_ByProcedura(id: number): Observable<IProceduraAttivita_RenderViewModel> {
    const url = this.base + 'GetForChecklistReadonly_ByProcedura?id=' + id;
    return this.http.get<IProceduraAttivita_RenderViewModel>(`${url}`);
  }
}
